export const Engine = {
    us: {
        engineName: 'laptops-usa',

        curPrefix : '$',
        curSufix: '',
        notAvlbl: 'Check Price',
        avlbl: 'Buy Now',

        under: 'Under',
        over: 'Over',
        upTo: 'Up to',
        andMore: 'and more',
        andLarger: 'and larger',
       
        sortByLbl: 'Sort by',
        brandLbl: 'Brand',
        availabilityLbl: 'Show only available laptops',

        priceLbl: 'Price',
        price1: '500',
        price2: '800',
        price3: '1200',
        price4: '1500',

        popSrchLbl: 'Popular searches',
        suitForLbl: 'Suitable for',
        cpuLbl: 'Cpu',
        gpuLbl: 'Graphics card',
        ramLbl: 'Ram',
        displSizeLbl: 'Display size',
        panelTypeLbl: 'Panel type',
        ssdLbl: 'SSD',
        hddLbl: 'HDD',

        weightLbl: 'Weight',
        weight1: 'Under 3.0 lbs',
        weight2: '3.0 - 5.0 lbs',
        weight3: '5.0 - 8.0 lbs',
        weight4: 'Over 8.0 lbs',
    },
    bg: {
        engineName: 'laptops-bg',

        curPrefix : '',
        curSufix: 'лв.',
        notAvlbl: 'Провери цената',
        avlbl: 'Купи сега',

        under: 'Под',
        over: 'Над',
        upTo: 'До',
        andMore: 'и повече',
        andLarger: 'и по-големи',

        sortByLbl: 'Сортирай по',
        brandLbl: 'Марка',
        availabilityLbl: 'Покажи само налични лаптопи',

        priceLbl: 'Цена',
        price1: '600',
        price2: '800',
        price3: '1200',
        price4: '1800',

        popSrchLbl: 'Популярни търсения',
        suitForLbl: 'Подходящ за',
        cpuLbl: 'Процесор',
        gpuLbl: 'Видеокарта',
        ramLbl: 'RAM',
        displSizeLbl: 'Размер на екрана',
        panelTypeLbl: 'Тип на панела',
        ssdLbl: 'SSD',
        hddLbl: 'HDD',

        weightLbl: 'Тегло',
        weight1: 'Под 1.4 кг',
        weight2: '1.4 - 2.3 кг',
        weight3: '2.3 - 3.6 кг',
        weight4: 'Над 3.6 кг',
    },
    gb: {
        engineName: 'laptops-uk',

        curPrefix : '£',
        curSufix: '',
        notAvlbl: 'Check Price',
        avlbl: 'Buy Now',

        under: 'Under',
        over: 'Over',
        upTo: 'Up to',
        andMore: 'and more',
        andLarger: 'and larger',
       
        sortByLbl: 'Sort by',
        brandLbl: 'Brand',
        availabilityLbl: 'Show only available laptops',

        priceLbl: 'Price',
        price1: '400',
        price2: '700',
        price3: '1000',
        price4: '1500',

        popSrchLbl: 'Popular searches',
        suitForLbl: 'Suitable for',
        cpuLbl: 'Cpu',
        gpuLbl: 'Graphics card',
        ramLbl: 'Ram',
        displSizeLbl: 'Display size',
        panelTypeLbl: 'Panel type',
        ssdLbl: 'SSD',
        hddLbl: 'HDD',

        weightLbl: 'Weight',
        weight1: 'Under 3.0 lbs',
        weight2: '3.0 - 5.0 lbs',
        weight3: '5.0 - 8.0 lbs',
        weight4: 'Over 8.0 lbs',
    },
    in: {
        engineName: 'laptops-in',

        curPrefix : '₹',
        curSufix: '',
        notAvlbl: 'Check Price',
        avlbl: 'Buy Now',

        under: 'Under',
        over: 'Over',
        upTo: 'Up to',
        andMore: 'and more',
        andLarger: 'and larger',
       
        sortByLbl: 'Sort by',
        brandLbl: 'Brand',
        availabilityLbl: 'Show only available laptops',

        priceLbl: 'Price',
        price1: '20000',
        price2: '30000',
        price3: '50000',
        price4: '80000',

        popSrchLbl: 'Popular searches',
        suitForLbl: 'Suitable for',
        cpuLbl: 'Cpu',
        gpuLbl: 'Graphics card',
        ramLbl: 'Ram',
        displSizeLbl: 'Display size',
        panelTypeLbl: 'Panel type',
        ssdLbl: 'SSD',
        hddLbl: 'HDD',

        weightLbl: 'Weight',
        weight1: 'Under 1.4 kg',
        weight2: '1.4 - 2.3 kg',
        weight3: '2.3 - 3.6 kg',
        weight4: 'Over 3.6 kg', 
    },
    it: {
        engineName: 'laptops-it',

        curPrefix : '€',
        curSufix: '',
        notAvlbl: 'Verifica il prezzo',
        avlbl: 'Acquista ora',

        under: 'Sotto',
        over: 'Sopra',
        upTo: 'Fino a',
        andMore: 'e oltre',
        andLarger: 'e più grandi',

        sortByLbl: 'Ordina per',
        brandLbl: 'Marca',
        availabilityLbl: 'Mostra solo laptop disponibili',

        priceLbl: 'Prezzo',
        price1: '300',
        price2: '500',
        price3: '800',
        price4: '1200',

        popSrchLbl: 'Ricerche popolari',
        suitForLbl: 'Adatto per',
        cpuLbl: 'Processore',
        gpuLbl: 'Scheda grafica',
        ramLbl: 'RAM',
        displSizeLbl: 'Dimensioni dello schermo',
        panelTypeLbl: 'Tipo di pannello',
        ssdLbl: 'SSD',
        hddLbl: 'HDD',

        weightLbl: 'Peso',
        weight1: 'Meno di 1,4 kg',
        weight2: '1,4 - 2,3 kg',
        weight3: '2,3 - 3,6 kg',
        weight4: 'Oltre 3,6 kg',
    },
    de: {
        engineName: 'laptops-de',

        curPrefix : '€',
        curSufix: '',
        notAvlbl: 'Preis prüfen',
        avlbl: 'Jetzt kaufen',

        under: 'Unter',
        over: 'Über',
        upTo: 'Bis zu',
        andMore: 'und mehr',
        andLarger: 'und größer',

        sortByLbl: 'Sortieren nach',
        brandLbl: 'Marke',
        availabilityLbl: 'Nur verfügbare Laptops anzeigen',

        priceLbl: 'Preis',
        price1: '300',
        price2: '500',
        price3: '800',
        price4: '1200',

        popSrchLbl: 'Beliebte Suchen',
        suitForLbl: 'Geeignet für',
        cpuLbl: 'Prozessor',
        gpuLbl: 'Grafikkarte',
        ramLbl: 'RAM',
        displSizeLbl: 'Bildschirmgröße',
        panelTypeLbl: 'Paneltyp',
        ssdLbl: 'SSD',
        hddLbl: 'HDD',

        weightLbl: 'Gewicht',
        weight1: 'Unter 1,4 kg',
        weight2: '1,4 - 2,3 kg',
        weight3: '2,3 - 3,6 kg',
        weight4: 'Über 3,6 kg', 
    },
    fr: {
        engineName: 'laptops-fr',
        curPrefix : '€',
        curSufix: '',
        notAvlbl: 'Vérifier le prix',
        avlbl: 'Acheter maintenant',

        under: 'Sous',
        over: 'Au-dessus de',
        upTo: 'Jusqu\'à',
        andMore: 'et plus',
        andLarger: 'et plus grands',

        sortByLbl: 'Trier par',
        brandLbl: 'Marque',
        availabilityLbl: 'Afficher seulement les ordinateurs portables disponibles',

        priceLbl: 'Prix',
        price1: '300',
        price2: '500',
        price3: '800',
        price4: '1200',

        popSrchLbl: 'Recherches populaires',
        suitForLbl: 'Convient pour',
        cpuLbl: 'Processeur',
        gpuLbl: 'Carte graphique',
        ramLbl: 'RAM',
        displSizeLbl: 'Taille de l\'écran',
        panelTypeLbl: 'Type de panneau',
        ssdLbl: 'SSD',
        hddLbl: 'HDD',

        weightLbl: 'Poids',
        weight1: 'Moins de 1,4 kg',
        weight2: '1,4 - 2,3 kg',
        weight3: '2,3 - 3,6 kg',
        weight4: 'Plus de 3,6 kg',
    },
    ca: {
        engineName: 'laptops-ca',

        curPrefix : '$',
        curSufix: '',
        notAvlbl: 'Check Price',
        avlbl: 'Buy Now',

        under: 'Under',
        over: 'Over',
        upTo: 'Up to',
        andMore: 'and more',
        andLarger: 'and larger',
       
        sortByLbl: 'Sort by',
        brandLbl: 'Brand',
        availabilityLbl: 'Show only available laptops',

        priceLbl: 'Price',
        price1: '500',
        price2: '800',
        price3: '1200',
        price4: '1500',

        popSrchLbl: 'Popular searches',
        suitForLbl: 'Suitable for',
        cpuLbl: 'Cpu',
        gpuLbl: 'Graphics card',
        ramLbl: 'Ram',
        displSizeLbl: 'Display size',
        panelTypeLbl: 'Panel type',
        ssdLbl: 'SSD',
        hddLbl: 'HDD',

        weightLbl: 'Weight',
        weight1: 'Under 1.4 kg',
        weight2: '1.4 - 2.3 kg',
        weight3: '2.3 - 3.6 kg',
        weight4: 'Over 3.6 kg', 
    },
    es: {
        engineName: 'laptops-es',

        curPrefix : '€',
        curSufix: '',
        notAvlbl: 'Comprobar precio',
        avlbl: 'Comprar ahora',
    
        under: 'Menos de',
        over: 'Más de',
        upTo: 'Hasta',
        andMore: 'y más',
        andLarger: 'y mayores',
    
        sortByLbl: 'Ordenar por',
        brandLbl: 'Marca',
        availabilityLbl: 'Mostrar solo laptops disponibles',
    
        priceLbl: 'Precio',
        price1: '600',
        price2: '800',
        price3: '1200',
        price4: '1800',
    
        popSrchLbl: 'Búsquedas populares',
        suitForLbl: 'Adecuado para',
        cpuLbl: 'Procesador',
        gpuLbl: 'Tarjeta gráfica',
        ramLbl: 'RAM',
        displSizeLbl: 'Tamaño de pantalla',
        panelTypeLbl: 'Tipo de panel',
        ssdLbl: 'SSD',
        hddLbl: 'HDD',
    
        weightLbl: 'Peso',
        weight1: 'Menos de 1.4 kg',
        weight2: '1.4 - 2.3 kg',
        weight3: '2.3 - 3.6 kg',
        weight4: 'Más de 3.6 kg',

    },
    au: {
        engineName: 'laptops-au',
        hidePrice: 'true',

        curPrefix : '$',
        curSufix: '',
        notAvlbl: 'Check Price',
        avlbl: 'Buy Now',

        under: 'Under',
        over: 'Over',
        upTo: 'Up to',
        andMore: 'and more',
        andLarger: 'and larger',
       
        sortByLbl: 'Sort by',
        brandLbl: 'Brand',
        availabilityLbl: 'Show only available laptops',

        priceLbl: 'Price',
        price1: '500',
        price2: '800',
        price3: '1200',
        price4: '1500',

        popSrchLbl: 'Popular searches',
        suitForLbl: 'Suitable for',
        cpuLbl: 'Cpu',
        gpuLbl: 'Graphics card',
        ramLbl: 'Ram',
        displSizeLbl: 'Display size',
        panelTypeLbl: 'Panel type',
        ssdLbl: 'SSD',
        hddLbl: 'HDD',

        weightLbl: 'Weight',
        weight1: 'Under 1,4 kg',
        weight2: '1,4 - 2,3 kg',
        weight3: '2,3 - 3,6 kg',
        weight4: 'Over 3,6 kg', 
    },
    cn: {
        engineName: 'laptops-usa',
        hidePrice: 'true',

        curPrefix : '¥',
        curSufix: '',
        notAvlbl: '查看价格',
        avlbl: '立即购买',

        under: '以下',
        over: '以上',
        upTo: '最高',
        andMore: '以上',
        andLarger: '以上',

        sortByLbl: '排序方式',
        brandLbl: '品牌',
        availabilityLbl: '仅显示有货的笔记本电脑',

        priceLbl: '价格',
        price1: '3000',
        price2: '5000',
        price3: '8000',
        price4: '12000',

        popSrchLbl: '热门搜索',
        suitForLbl: '适合',
        cpuLbl: '处理器',
        gpuLbl: '显卡',
        ramLbl: '内存',
        displSizeLbl: '显示器尺寸',
        panelTypeLbl: '显示器类型',
        ssdLbl: '固态硬盘',
        hddLbl: '机械硬盘',

        weightLbl: '重量',
        weight1: '3.0磅以下',
        weight2: '3.0-5.0磅',
        weight3: '5.0-8.0磅',
        weight4: '8.0磅以上',
    },
    jp: {
        engineName: 'laptops-jp',
        
        curPrefix : '¥',
        curSufix: '',
        notAvlbl: '価格を確認する',
        avlbl: '今すぐ購入',

        under: '未満',
        over: '以上',
        upTo: '最大',
        andMore: '以上',
        andLarger: '以上',

        sortByLbl: '並べ替え',
        brandLbl: 'ブランド',
        availabilityLbl: '在庫のみを表示',

        priceLbl: '価格',
        price1: '50000',
        price2: '80000',
        price3: '120000',
        price4: '180000',

        popSrchLbl: '人気のある検索',
        suitForLbl: '適した用途',
        cpuLbl: 'CPU',
        gpuLbl: 'グラフィックスカード',
        ramLbl: 'RAM',
        displSizeLbl: 'ディスプレイサイズ',
        panelTypeLbl: 'パネルタイプ',
        ssdLbl: 'SSD',
        hddLbl: 'HDD',

        weightLbl: '重さ',
        weight1: '3.0ポンド未満',
        weight2: '3.0〜5.0ポンド',
        weight3: '5.0〜8.0ポンド',
        weight4: '8.0ポンド以上',
    },
    be:{
        engineName: 'laptops-be',

        curPrefix: '€',
        curSufix: '',
        notAvlbl: 'Prijs controleren',
        avlbl: 'Nu kopen',

        under: 'Onder',
        over: 'Boven',
        upTo: 'Tot',
        andMore: 'en meer',
        andLarger: 'en groter',

        sortByLbl: 'Sorteren op',
        brandLbl: 'Merk',
        availabilityLbl: 'Alleen beschikbare laptops tonen',

        priceLbl: 'Prijs',
        price1: '450',
        price2: '720',
        price3: '1080',
        price4: '1350',

        popSrchLbl: 'Populaire zoekopdrachten',
        suitForLbl: 'Geschikt voor',
        cpuLbl: 'CPU',
        gpuLbl: 'Grafische kaart',
        ramLbl: 'RAM',
        displSizeLbl: 'Schermafmeting',
        panelTypeLbl: 'Paneeltype',
        ssdLbl: 'SSD',
        hddLbl: 'HDD',

        weightLbl: 'Gewicht',
        weight1: 'Onder 1,4 kg',
        weight2: '1,4 - 2,3 kg',
        weight3: '2,3 - 3,6 kg',
        weight4: 'Meer dan 3,6 kg',
    },
    nl:{
        engineName: 'laptops-nl',

        curPrefix: '€',
        curSufix: '',
        notAvlbl: 'Prijs controleren',
        avlbl: 'Nu kopen',

        under: 'Onder',
        over: 'Boven',
        upTo: 'Tot',
        andMore: 'en meer',
        andLarger: 'en groter',

        sortByLbl: 'Sorteren op',
        brandLbl: 'Merk',
        availabilityLbl: 'Alleen beschikbare laptops tonen',

        priceLbl: 'Prijs',
        price1: '450',
        price2: '720',
        price3: '1080',
        price4: '1350',

        popSrchLbl: 'Populaire zoekopdrachten',
        suitForLbl: 'Geschikt voor',
        cpuLbl: 'CPU',
        gpuLbl: 'Grafische kaart',
        ramLbl: 'RAM',
        displSizeLbl: 'Schermafmeting',
        panelTypeLbl: 'Paneeltype',
        ssdLbl: 'SSD',
        hddLbl: 'HDD',

        weightLbl: 'Gewicht',
        weight1: 'Onder 1,4 kg',
        weight2: '1,4 - 2,3 kg',
        weight3: '2,3 - 3,6 kg',
        weight4: 'Meer dan 3,6 kg',
    },
    pl:{
        engineName: 'laptops-pl',

        curPrefix: 'zł',
        curSufix: '',
        notAvlbl: 'Sprawdź cenę',
        avlbl: 'Kup teraz',

        under: 'Poniżej',
        over: 'Powyżej',
        upTo: 'Do',
        andMore: 'i więcej',
        andLarger: 'i większe',

        sortByLbl: 'Sortuj według',
        brandLbl: 'Marka',
        availabilityLbl: 'Pokaż tylko dostępne laptopy',

        priceLbl: 'Cena',
        price1: '2100',
        price2: '3400',
        price3: '5100',
        price4: '6400',

        popSrchLbl: 'Popularne wyszukiwania',
        suitForLbl: 'Odpowiednie dla',
        cpuLbl: 'Procesor',
        gpuLbl: 'Karta graficzna',
        ramLbl: 'Pamięć RAM',
        displSizeLbl: 'Rozmiar ekranu',
        panelTypeLbl: 'Typ panelu',
        ssdLbl: 'Dysk SSD',
        hddLbl: 'Dysk HDD',

        weightLbl: 'Waga',
        weight1: 'Poniżej 1,4 kg',
        weight2: '1,4 - 2,3 kg',
        weight3: '2,3 - 3,6 kg',
        weight4: 'Powyżej 3,6 kg',
    },
    sg:{
        engineName: 'laptops-sg',

        curPrefix: '$',
        curSufix: '',
        notAvlbl: 'Check Price',
        avlbl: 'Buy Now',

        under: 'Under',
        over: 'Over',
        upTo: 'Up to',
        andMore: 'and more',
        andLarger: 'and larger',

        sortByLbl: 'Sort by',
        brandLbl: 'Brand',
        availabilityLbl: 'Show only available laptops',

        priceLbl: 'Price',
        price1: '500',
        price2: '800',
        price3: '1200',
        price4: '1500',

        popSrchLbl: 'Popular searches',
        suitForLbl: 'Suitable for',
        cpuLbl: 'CPU',
        gpuLbl: 'Graphics card',
        ramLbl: 'RAM',
        displSizeLbl: 'Display size',
        panelTypeLbl: 'Panel type',
        ssdLbl: 'SSD',
        hddLbl: 'HDD',

        weightLbl: 'Weight',
        weight1: 'Under 3.0 lbs',
        weight2: '3.0 - 5.0 lbs',
        weight3: '5.0 - 8.0 lbs',
        weight4: 'Over 8.0 lbs',
    },
    se:{
        engineName: 'laptops-se',

        curPrefix: '',
        curSufix: 'kr',
        notAvlbl: 'Kontrollera pris',
        avlbl: 'Köp nu',

        under: 'Under',
        over: 'Över',
        upTo: 'Upp till',
        andMore: 'och mer',
        andLarger: 'och större',

        sortByLbl: 'Sortera efter',
        brandLbl: 'Märke',
        availabilityLbl: 'Visa endast tillgängliga laptops',

        priceLbl: 'Pris',
        price1: '5400',
        price2: '8700',
        price3: '13000',
        price4: '16200',

        popSrchLbl: 'Populära sökningar',
        suitForLbl: 'Lämplig för',
        cpuLbl: 'Processor',
        gpuLbl: 'Grafikkort',
        ramLbl: 'RAM',
        displSizeLbl: 'Skärmstorlek',
        panelTypeLbl: 'Paneltyp',
        ssdLbl: 'SSD',
        hddLbl: 'HDD',

        weightLbl: 'Vikt',
        weight1: 'Under 1,4 kg',
        weight2: '1,4 - 2,3 kg',
        weight3: '2,3 - 3,6 kg',
        weight4: 'Över 3,6 kg',
    },

}

